export default function ServiceHeroSection() {
  return (
    <section
      className="relative flex items-center justify-center overflow-hidden"
      style={{ paddingTop: '72px', minHeight: '460px' }}
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://media.genaiweb.ai/8a4f04ed-3960-472b-978d-5363f01a3123/service-hero.jpeg"
          alt="無料相談から成婚までの流れ"
          className="w-full h-full object-cover object-center"
          loading="eager"
        />
        <div className="absolute inset-0" style={{ background: 'rgba(74,55,40,0.52)' }} />
      </div>
      <div className="relative z-10 w-full content-width text-center py-20">
        <div className="animate-fadeIn">
          <p
            className="inline-block px-4 py-1 rounded-full mb-5 text-sm font-bold"
            style={{ background: 'rgba(255,255,255,0.2)', color: '#f5d9b8', border: '1px solid rgba(255,255,255,0.4)' }}
          >
            活動の流れ
          </p>
          <h1 className="text-white mb-6" style={{ textShadow: '0 2px 8px rgba(0,0,0,0.4)' }}>
            無料相談～成婚までの流れ
          </h1>
          <p className="text-white/90 mx-auto max-w-2xl" style={{ fontSize: '18px' }}>
            わかりやすく丁寧にご説明いたします。
            <br className="hidden sm:block" />
            あなたに合ったペースで、確かなご縁を見つけてください。
          </p>
        </div>
      </div>
    </section>
  );
}
